<template>
  <div class="export-description">
    <div class="description">
      {{ $t('leadExport.description') }}
    </div>
    <div class="number-of-leads">
      {{ $t('leadExport.numberOfLeads', { target: numberOfTargetLeads, all: numberOfLeads }) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TNumberOfLeadsProps } from './types';

type TProps = TNumberOfLeadsProps;

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.export-description {
  @include m-flex-align-start;

  .number-of-leads {
    margin-left: auto;
    font-weight: $font-weight-bold;
  }
}
</style>
